




























































































import { mapState } from 'vuex';
import NavBarMenu from '@/modules/core/components/NavBarMenu.vue';
import AuthenticationService from '@/auth.service';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    NavBarMenu,
  },
  computed: mapState(['isNavBarVisible', 'isAsideMobileExpanded', 'userName']),
})
export default class NavBar extends Vue {
  public userName!: string;
  public isNavBarVisible!: boolean;
  public isAsideMobileExpanded!: boolean;
  public isMenuNavBarActive = false;
  public AuthenticationService: typeof AuthenticationService =
    AuthenticationService;

  public get menuNavBarToggleIcon(): string {
    return this.isMenuNavBarActive ? 'close' : 'dots-vertical';
  }

  public get menuToggleMobileIcon(): string {
    return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger';
  }

  public menuToggleMobile(): void {
    this.$store.commit('asideMobileStateToggle');
  }

  public menuNavBarToggle(): void {
    this.isMenuNavBarActive = !this.isMenuNavBarActive;
  }

  public logout(): void {
    AuthenticationService.logout();
  }
}
